module.exports = __webpack_public_path__ + "static/media/email-error.a9102159.svg";